import React from 'react'
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined'
import IconButton from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import RoofPitch from './RoofPitch'
import CompassControl from './CompassControl'
import { Alerts1,Alerts2 } from './Alerts'
import ErrorDialog from './ErrorDialog'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Toolbar } from '@mui/material';
import Icon from '@mui/material/Icon';
import { green,red } from '@mui/material/colors';
import {getSolarSavigsFromServer, GetPanels, GetInstallationLocations, GetFlgFromID, APICreateDataSheets, APIGetSolarOptimisers} from './Api'

import { connect } from 'react-redux'
import { addoptimisers,addpanels,initpanels, addpaneltoarray,removefromarray,updateelecrate, updateLayoutSets } from "./actions";
import PanelLayoutSets from './components/PanelLayoutSets';



let panels = []
let installation_location = []
let optimisers = []
// Our Green Solar Buttons
 const ColorButton = withStyles((theme) => ({
    root: {
      color: '#ffffff', // theme.palette.getContrastText(lightGreen[50]),
      backgroundColor: '#04c659',
      '&:hover': {
        backgroundColor: '#04a659',
      },
    },
    
}))(Button);


// Create our Tab Panels for Our Tabs.
// THese will hold the Details of each Panel Array
const  TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    let selval = 0
    if(!isNaN(value)) selval = value
    return (
      <Typography
      className={styles.tabpanel}
        component="div"
        role="tabpanel"
        hidden={selval !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {selval === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
}
  
// Prop Type for the TabPanels
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
// Get The Props for the Selected Tab - Index denotes the selected tab
function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

// Set the width of the Tabs
const tabwidth = 40;

// Create Delete Icon Button - Just to save space in main code
const  DeleteIconButton = (props) => {
    return( 
        <IconButton aria-label="delete" color="secondary" 
            onClick={props.onClick}  > 
            <DeleteForeverOutlinedIcon /> 
        </IconButton>
    );
}

// No Added functionality just a TableCell but makes bottom code look tidier as lots of repetition on Cells
const SmallCell = (props) => {
    const { children,  cn, ...other } = props;
    return (<TableCell component="th" scope="row" className={cn} {...other} >{children}</TableCell>);
}

const widthModifier = {
    default_tab:{
        backgroundColor: '#6FCAE7',
        color: '#000000',
        minWidth: `${tabwidth}px`,
        width: `${tabwidth}px`,
        fontSize: 12,
    },
    active_tab: {
        backgroundColor: '#6FCAE7',
        color: '#ffffff',
        minWidth: `${tabwidth}px`,
        width: `${tabwidth}px`,
        fontSzie: 16,
    }
};

const console_log = (text) => { 
    return  // Comment out if yoy want logging
    console.log(text)
}

class CalculationPage extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            flg_id: props.flg_id,
            hasItems: false,
            currentArray: 0,
            numArrays: 0,
            panelArrays: [],
            toggleState: false,
            confirmDelete: false,
            deleteArrayNo: -1,
            origprops: props,
            postcode: props.postcode,
            vo: props.vo,
            battery: props.battery,
            //elecrate:  props.elecrate,
            elecconsumption: props.elecconsumption,
            electric_estimated: props.electric_estimated,
            selfconsumption: props.selfconsumption,
            gasconsumption: props.gasconsumption,
            gasrate: props.gasrate,
            gas_estimated: props.gas_estimated,
            calculating: true,
            showArrayData: false,
            tariff: null,
            selected_tariff: props.selected_tariff,
            errTitle: '',
            errText: '',
            errOpen: false,
            name: '',
            full_address: '',
            dontupdateAll: false, 

      }
    }

    componentDidMount = async () => {
        panels = await GetPanels()
        installation_location = await GetInstallationLocations()
        optimisers = await APIGetSolarOptimisers()
        this.props.addoptimisers(optimisers) // Add optimisers to Redux
        this.props.addpanels(panels) // Add optimisers to Redux

        console_log(optimisers)
        if(!this.props.panelArrays || (this.props.panelArrays && this.props.panelArrays.length === 0) ) {
            console_log("no Arrays so Adding one!")
            this.addArrays(1)
        }
        var name = ''
        var full_address = ''
        var flg_rec = null
        const ret = await GetFlgFromID(this.props.flg_id)
        if(ret && ret.status && ret.payload.message === "OK") 
            flg_rec = ret.payload

        if(flg_rec && typeof flg_rec !== "undefined" ) {
            name = flg_rec.fullname 
        // Get name and Full full_address we will need this for the Mail Merge
            var full_address = ''
            var flds = ["address2","address3","towncity","postcode"]

            full_address = flg_rec.address ? flg_rec.address : ''
            flds.map(item =>{
                if(flg_rec[item]) 
                    full_address += full_address ? ", " + flg_rec[item] : flg_rec[item]
            })
        }
        this.props.initpanels(this.props.panelArrays)
        this.setState({origprops: this.props,postcode: this.props.postcode, 
            vo: this.props.vo,  battery: this.props.battery,
            //elecrate: this.props.elecrate,
            elecconsumption: this.props.elecconsumption,
            electric_estimated: this.props.electric_estimated,
            selfconsumption: this.props.selfconsumption,
            selected_tariff: this.props.selected_tariff,
            gasconsumption: this.props.gasconsumption,
            gasrate: this.props.gasrate,
            gas_estimated: this.props.gas_estimated,
            panels, 
            panelArrays: this.props.panelArrays,
            flg_id: this.props.flg_id,
            name,
            full_address,
            calculating: false
        })
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        // do things with nextProps.someProp and prevState.cachedSomeProp
        if(prevState.origprops !== nextProps)
          return {
            origprops: nextProps,
            postcode: nextProps.postcode,
            panelArrays:  nextProps.panelArrays,
            battery: nextProps.battery,
            vo: nextProps.vo,
            //elecrate: nextProps.elecrate,
            elecconsumption: nextProps.elecconsumption,
            electric_estimated: nextProps.electric_estimated,
            selfconsumption: nextProps.selfconsumption,
            selected_tariff: nextProps.selected_tariff,
            gasconsumption: nextProps.gasconsumption,
            gasrate: nextProps.gasrate,
            gas_estimated: nextProps.gas_estimated,
            flg_id: nextProps.flg_id,
            // ... other derived state properties
        };
        return null
    }
    getStyle = (isActive) => {
        return isActive ? widthModifier.active_tab : widthModifier.default_tab
    }

    // Roof Pitch has been updated so change orientation on currently selected Solar Array
    getRoofPitchOnChangeEvente = e => {
        // Take a copy of the current panelArrays - DeepCopy
        let panelArraysCopy = JSON.parse(JSON.stringify(this.state.panelArrays))
        //make changes to panelArrays
        panelArraysCopy[this.state.currentArray].roofPitch = e.roofpitch
        this.setState({
            panelArrays: panelArraysCopy 
            }) 

        this.props.onChange({panelArrays: panelArraysCopy, origprops: this.props})
    }

    // Compass has been updated so change orientation on currently selected Solar Array
    getCompassOnChangeEvente = e => {
        // Take a copy of the current panelArrays - DeepCopy
        let panelArraysCopy = JSON.parse(JSON.stringify(this.state.panelArrays))
        //make changes to panelArrays
        panelArraysCopy[this.state.currentArray].orientation = e.degrees
        this.setState({
            panelArrays: panelArraysCopy 
        }) 
        this.props.onChange({panelArrays: panelArraysCopy, origprops: this.props})

    }

    // Tab has changed so update current Solar Array state variable to reflect change
    handleTabChange = (event, value) => {
        this.setState({currentArray: value, toggleState: !this.state.toggleState})
    }

    // Number of Solar Arrays to be changed - This an only be more than is currently allocated
    handleChange = (event) => {
        const name = event.target.name;

        if( event.target.value <= this.state.panelArrays.length) {
            alert("You can only select a number greater than the current number of panel Arrays. If you wish to Delete some Panel Array then use the Delete Icon Next to the Array Congifuration ")
            return;
        }

        if(name === "numArrays") 
            this.addArrays(event.target.value)
    }

    // Add New Solar Arrays to the end of PanelArrays
    addArrays = (numArrays) => {
        if(typeof this.state.panelArrays !== "undefined" && this.state.panelArrays.length < numArrays && this.state.panelArrays.length > 0) {
            const panel = panels[8];
            console_log("AddArrays");
            console_log(panel)
            this.props.addpaneltoarray(numArrays)
            
            let panelArraysCopy = JSON.parse(JSON.stringify(this.state.panelArrays))
            for(var i=panelArraysCopy.length; i<numArrays; i++)
                panelArraysCopy.push({
                    key: i, 
                    arrayNumber: i+1,
                    numPanels: 8,
                    panel_id: this.state.panelArrays[0].panel_id,
                    panelType: this.state.panelArrays[0].panelType,
                    watts: this.state.panelArrays[0].watts,
                    panelModel: this.state.panelArrays[0].panelModel ,
                    roofPitch: 35, 
                    orientation: 0,
                    shading: 0.9,
                    description: 'Array ' + (i+1) + ' Description',
                    moneysaving: 0.00,
                    kwphsavings: 0.00,
                    birdprotection: false,
                    unit_cost: this.state.panelArrays[0].unit_cost,
                    customer_price: this.state.panelArrays[0].customer_price,
                    unit_qty: this.state.panelArrays[0].unit_qty,
                    installation_location: {},
                    calcData: {}
                    

                })
            this.setState({panelArrays: panelArraysCopy, hasItems: panelArraysCopy.length > 0 ? true : false, numArrays})
            this.props.onChange({panelArrays: panelArraysCopy, origprops: this.props})
        }else {
            let panel = panels.find(x => x.panel_id === 9)
            if(typeof panel == "undefined" || !panel )
                panel = panels[8];
            if(typeof this.state.panelArrays === "undefined" || this.state.panelArrays.length == 0 ) {
                let panelArraysCopy = []
                this.props.addpaneltoarray(numArrays)
                i = 0;
                for(var i=0; i<numArrays; i++)
                    panelArraysCopy.push({
                        key: i, 
                        arrayNumber: i+1,
                        numPanels: 8,
                        panel_id: panel.panel_id,
                        panelType: panel.description + ' - ' + panel.type,
                        watts: panel.watts,
                        panelModel: panel.model,
                        roofPitch: 35, 
                        orientation: 0,
                        shading: 0.9,
                        description: 'Array ' + (i+1) + ' Description',
                        moneysaving: 0.00,
                        kwphsavings: 0.00,
                        birdprotection: false,
                        unit_cost: panel.unit_cost,
                        customer_price: panel.customer_price,
                        unit_qty: panel.unit_qty,
                        installation_location: {},
                        calcData: {}
                    })
                this.setState({panelArrays: panelArraysCopy, hasItems: panelArraysCopy.length > 0 ? true : false, numArrays})
                this.props.onChange({panelArrays: panelArraysCopy, origprops: this.props})           
            }            
        }
    }

    // Delete an Array Icon has been pushed.
    deleteArray = (arrayNo) => {  
        // Set confirmDelete to true will show delete Dialog
        this.setState({confirmDelete: true,deleteArrayNo: arrayNo})
    }

    // Handle the Outcome of Delete an Array.
    handleCloseConfDel = (value) => {
        if(isNaN(value))
            return
        if(this.state.deleteArrayNo === -1)
            this.setState({confirmDelete: false,});

        if(!value) {
            this.setState({confirmDelete: false,});
        }
        else {
            // Filter our Array
            let hasItems = true;
            let newArray = this.state.panelArrays.filter(item => item.key !== this.state.deleteArrayNo)
            // Now Update Keys and Numbers
            for(var i=0; i<newArray.length; i++) {
                newArray[i].key = i;
                newArray[i].arrayNumber = i + 1;
            }
            if( newArray.length === 0)
            hasItems = false;
            this.props.removefromarray(this.state.deleteArrayNo)
            this.setState({confirmDelete: false,panelArrays: newArray,deleteArrayNo: -1,currentArray: 0, numArrays: newArray.length,hasItems});
            this.props.onChange({panelArrays: newArray, origprops: this.props})
        }
    }

    handleCloseArrayDataDialog = () => {
        this.setState({showArrayData: false})
    }

    // Update the number of panels 
    handleUpdatePanels = (event) => {
        console_log(event)
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        let selPanel = panels.find(x => x.panel_id === event.target.value)
        for(let i =0; i<this.state.panelArrays.length; i++) {
            //console.log(`i=${i} dontUpdate=${this.state.panelArrays[i].dontupdateAll} curArr =${this.state.currentArray}`)
            if(this.state.dontupdateAll ) {
                if(i == this.state.currentArray ) {
                    newArray[i].panelType = selPanel.description + ' - ' + selPanel.type;
                    newArray[i].watts = selPanel.watts;
                    newArray[i].panel_id= selPanel.panel_id;
                    newArray[i].panelModel = selPanel.description;
                    newArray[i].unit_cost = selPanel.unit_cost;
                    newArray[i].customer_price = selPanel.customer_price;
                    newArray[i].unit_qty = selPanel.unit_qty;
                    newArray[i].width_mm = selPanel.width_mm || 1134;
                    newArray[i].height_mm = selPanel.height_mm || 1722;
                }
            }else {
                newArray[i].panelType = selPanel.description + ' - ' + selPanel.type;
                newArray[i].watts = selPanel.watts;
                newArray[i].panel_id= selPanel.panel_id;
                newArray[i].panelModel = selPanel.description;
                newArray[i].unit_cost = selPanel.unit_cost;
                newArray[i].customer_price = selPanel.customer_price;
                newArray[i].unit_qty = selPanel.unit_qty;
                newArray[i].width_mm = selPanel.width_mm || 1134;
                newArray[i].height_mm = selPanel.height_mm || 1722;
            }
        }
        newArray[this.state.currentArray].birdprotection = this.state.panelArrays[this.state.currentArray].birdprotection;
        newArray[this.state.currentArray].installation_location = this.state.panelArrays[this.state.currentArray].installation_location
        console_log(newArray)
        this.setState({panelArrays: newArray})     
        this.props.onChange({panelArrays: newArray, origprops: this.props})
    }
  
    UpdateNumPanels = (event) => {
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        const ia = this.state.currentArray
        newArray[ia].numPanels = event.target.value;
        if(typeof newArray[ia].optimiser !=="undefined" && newArray[ia].optimiser.type === "SE") 
            newArray[ia].qty_optimisers = event.target.value
        this.setState({panelArrays: newArray})
        this.props.onChange({panelArrays: newArray, origprops: this.props})
    }

    // Update layout sets for an array (for rails/hooks calculation)
    handleLayoutSetsChange = (arrayKey, newLayoutSets) => {
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        const arrayIndex = newArray.findIndex(arr => arr.key === arrayKey)
        if (arrayIndex >= 0) {
            newArray[arrayIndex].layoutSets = newLayoutSets
            this.setState({ panelArrays: newArray })
            this.props.onChange({ panelArrays: newArray, origprops: this.props })
        }
    }

    // Update the Array Description - From the TabPanel
    UpdateDescription = (event) => { 
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        newArray[this.state.currentArray].description = event.target.value;
        this.setState({panelArrays: newArray}) 
        this.props.onChange({panelArrays: newArray, origprops: this.props})

    }

    // Update the Orientation from the TabPanel not the Compass
    handlePanelCompassChange = (event) => {
        let d = parseInt(Number(event.target.value));
        if( d>175) d = 175
        if( d<0) d = 0;
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        newArray[this.state.currentArray].orientation = d;
        this.setState({panelArrays: newArray})  
        this.props.onChange({panelArrays: newArray, origprops: this.props})
    }

    panelCompassOnBlur = (event ) => {
        let e = event;
        e.target.value= Math.round(parseInt(Number(event.target.value)) / 5) * 5;
        this.handlePanelCompassChange(e)
    }

    // Update the RoofPitch from the TabPanel not the Compass
    handlePanelRoofPitchChange = (event) => {
        let d = parseInt(Number(event.target.value));
        if(isNaN(d) || d == "") d = 0
        if( d>90) d = 90
        if( d<0) d = 0;
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        newArray[this.state.currentArray].roofPitch = d;
        this.setState({panelArrays: newArray})  
        this.props.onChange({panelArrays: newArray, origprops: this.props})
    }

    handlePanelShadingChange = (event) => {
        let d = Number(event.target.value);
        if( d>1) d = 1
        if( d<0) d = 0;
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        newArray[this.state.currentArray].shading = d;
        this.setState({panelArrays: newArray})  
        this.props.onChange({panelArrays: newArray, origprops: this.props})
    }
    
    handleBirdProtection = () => {
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        const birdprotection = newArray[this.state.currentArray].birdprotection   
        newArray[this.state.currentArray].birdprotection = !birdprotection
        this.setState({panelArrays: newArray})  
        this.props.onChange({panelArrays: newArray, origprops: this.props})
    }
    handleInstallationLocation = (event) => {
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        const selected_id = parseInt(event.target.value)
        const selInstallationLocation = installation_location.find(x => parseInt(x.installation_id) === selected_id)
        if(selInstallationLocation) {
            newArray[this.state.currentArray].installation_location = JSON.parse(JSON.stringify(selInstallationLocation))
            this.setState({panelArrays: newArray})  
            this.props.onChange({panelArrays: newArray, origprops: this.props})
        }else   {
            console.log(`Installation location not found for id ${selected_id}`)
            console.log(newArray)
        }
    }

    handleOptimiserChange = (event) => {
        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        const arr_id = this.state.currentArray
        const solaroptimiser_uid = parseInt(event.target.value)
        const selOptimiser = optimisers.find(x => parseInt(x.uid) === solaroptimiser_uid)

        if(selOptimiser && typeof selOptimiser !== "undefined") {
            if(selOptimiser.type === "SE") {
                for(var i=0; i<newArray.length; i++){
                    newArray[i].qty_optimisers = parseInt(newArray[i].numPanels)
                    newArray[i].optimiser = JSON.parse(JSON.stringify(selOptimiser))
                }
            }else {
                for(var i=0; i<newArray.length; i++){
                    if(typeof newArray[i].optimiser.type !== "undefined") 
                        if( newArray[i].optimiser.type == 'SE')
                            newArray[i].optimiser = optimisers[0]       // FIrst is always None
                }
                newArray[arr_id].qty_optimisers  = parseInt(newArray[arr_id].numPanels)
                newArray[arr_id].optimiser = JSON.parse(JSON.stringify(selOptimiser))
            }
        }
        this.setState({panelArrays: newArray})  
        this.props.onChange({panelArrays: newArray, origprops: this.props})
    }
    


    handleSolarOptimiserQty = (event) => {
        console_log("handleSolarOptimiserQty")

        let newArray = JSON.parse(JSON.stringify(this.state.panelArrays))
        const arr_id = this.state.currentArray
        var qty = parseInt(event.target.value)
        if(typeof qty == "undefined" || !qty || qty == "" ) qty = 0   
        if(qty > parseInt(newArray[arr_id].numPanels) )  qty = parseInt(newArray[arr_id].numPanels)
        newArray[arr_id].qty_optimisers  = qty
        this.setState({panelArrays: newArray})  
        this.props.onChange({panelArrays: newArray, origprops: this.props})         
    }

    // Calculate the Enerygy Data for the given array
  

    APICalcSolarArray = async () => {
        this.setState({calculating: true})
        var payload = {
            token:                  this.state.token,
            postcode:               this.state.postcode ? this.state.postcode.toUpperCase() : '',
            vo:                     this.state.vo,
            selfconsumption:        this.state.selfconsumption,
            elecrate:               this.props.elecrate,
            electric_estimated:     this.state.electric_estimated,
            elecconsumption:        this.state.elecconsumption,
            gasconsumption:         this.state.gasconsumption,
            gasrate:                this.state.gasrate,
            gas_estimated:          this.state.gas_estimated,
            panelArrays:            this.state.panelArrays[this.state.currentArray],
            battery:                this.state.battery,
            selected_tariff:        this.state.selected_tariff,     // New Smart Tariff selected
            total_pv_output:        0,
            name:                   this.state.name,
            full_address:           this.state.full_address

        }
        console_log(payload)
        // Loop round arrays and get eneryg for Each Panel
        var total_power = 0
        var status = true
        var result
        const panelArrays = this.state.panelArrays
        for(var i=0; i<panelArrays.length; i++) {
            payload.panelArrays =  panelArrays[i]
            result = await getSolarSavigsFromServer(payload, 'CalcSolarArray')
            if(result.status) {
                total_power += result.payload.panel_production_energy
                panelArrays[i].irradiance = result.payload.irradiance
                panelArrays[i].zone = result.payload.zone
            }
            else {
                this.setState({
                    calculating: false,
                    errOpen: true,
                    errTitle: 'Error Getting Panel Details',
                    errText: 'The following error occured<br/>' + result.error +'<br/>Try again to see if the error is fixed or report to IT Support.' ,
                })
                return
            }
        }
            // Now try and get Self Consumption data 
        if(payload.elecconsumption === "" || payload.elecconsumption === 0) {
            result.payload.panel_useable_energy = 0;
            result.payload.panel_and_battery_useable_energy = 0
            result.payload.battery_uplift = 0
            result.payload.elecconsumption = 0;
            let  panelArraysCopy = JSON.parse(JSON.stringify
                (this.state.panelArrays));
            panelArraysCopy[this.state.currentArray].calcData = result.payload;
            this.setState({
                panelArrays: panelArraysCopy,
                showArrayData: true,
                calculating: false,
            })      
            return          
        }
        payload.total_pv_output = total_power
        payload.panelArrays = panelArrays;
        //let sc = await getSolarSavigsFromServer(payload, 'CalcSelfConsumption') 
        let sc = await getSolarSavigsFromServer(payload, 'SolarArraysReport') 
        
        console_log("CalcSelfConsumption returned")
        console_log(sc)
        if(sc.status) {

            // Create a PDF Version of the Report for epvs and Installations
            const html_page = this.props.flg_id + "_epvs.html"
            const pdf_page = this.props.flg_id + "_epvs.pdf"
            var html = "<html><head><style> body{font-family: Arial,Helvetica; font-size: 12pt;margin: 10px 10px 10px 10px} </style></head> <body>";
            html += sc.report + "</body></html>"
            await APICreateDataSheets(this.props.flg_id,html,html_page,pdf_page,"portrait")

            result.payload.panel_useable_energy = sc.solar;
            result.payload.panel_and_battery_useable_energy = sc.solar_battery
            result.payload.battery_uplift = sc.battery_uplift
            result.payload.elecconsumption = payload.elecconsumption
            result.payload.report = sc.report;
            result.payload.mgd003_report = sc.mgd003_report;
            let  panelArraysCopy = JSON.parse(JSON.stringify
                (this.state.panelArrays));
                
            panelArraysCopy[this.state.currentArray].calcData = result.payload;
            this.setState({panelArrays: panelArraysCopy, calculating: false, showArrayData: true})
        }else
            this.setState({
                calculating: false,
                errOpen: true,
                errTitle: 'Error Getting Self Consumption Data',
                errText: 'The following error occured<br/>' + sc.error +'<br/>Try again to see if the error is fixed or report to IT Support.' ,
            })
        
    }

    DontUpdateAll = () => {
        this.setState({dontupdateAll: !this.state.dontupdateAll})
    }


    handleErrDaialogClose = () => {
        this.setState({errOpen: false})
    }

    render() {
        const { classes } = this.props;
        const selectedIndex = this.state.currentArray;
        const curArray = this.state.panelArrays.length > 0 ? this.state.panelArrays[selectedIndex] : {}
        const hasItems = this.state.panelArrays.length > 0 ? true : false
        const open = this.state.calculating;
        let solaroptimiser_uid = 0
        let qty_optimisers  = 0
        let optimiser_type = ''
        let installation_location_id = 0
        let pman = ""
        if( curArray && curArray.installation_location ) {
            installation_location_id = parseInt(curArray.installation_location.installation_id )
            if(isNaN(installation_location_id)) installation_location_id = 0
        }

        if(curArray && typeof curArray.optimiser !== "undefined" ) {
            console_log("Get Optimiser Details")
            solaroptimiser_uid = curArray.optimiser.uid
            qty_optimisers = curArray.qty_optimisers
            optimiser_type = curArray.optimiser.type
        }
        if(typeof qty_optimisers == "undefined") qty_optimisers = 0
        console_log(solaroptimiser_uid)
        console_log(qty_optimisers)

        return (

        <div className={classes.root} >
            <Backdrop className={classes.backdrop} open={open} >
                <CircularProgress color="inherit" size={100}/>
            </Backdrop>
            <Alerts1
                open={this.state.confirmDelete} onClose={this.handleCloseConfDel } state = {this.state}
            />
            <Alerts2 
                open={this.state.showArrayData} state={this.state} onClose={this.handleCloseArrayDataDialog }
            />
            <ErrorDialog title={this.state.errTitle} text={this.state.errText} open={this.state.errOpen} onClose={this.handleErrDaialogClose} />

            <AppBar position="static" style={{background: '#ffffff'}}   >
                <Toolbar >                     
                    <FormControl className={classes.formControl} >
                        <InputLabel id="numArraysLabel"># Arrays</InputLabel>
                        <Select
                        className={classes.numArraysSelectStyle}
                            labelid="numArraysLabel"  value={this.state.panelArrays.length}
                            onChange={this.handleChange} id= "numArrays" name="numArrays" >
                            {[0,1,2,3,4,5,6,7,8,9,10].map((item) => ( <MenuItem key={item} value={item}>{item}</MenuItem> ))}
                        </Select>
                    </FormControl>
                    {this.state.panelArrays && this.state.panelArrays.length > 0 &&
                    <Tabs className={classes.tabs}  value={this.state.currentArray} onChange={this.handleTabChange} 
                            aria-label="simple tabs"  textColor="inherit" >
                        { this.state.panelArrays.map((item) => { return( <Tab style={ this.getStyle(selectedIndex === item.key ) } label={item.arrayNumber}  {...a11yProps(item.arrayNumber)} key={item.key} value={item.key} /> )} )}
                    </Tabs>
                    }   
                </Toolbar> 
            </AppBar>
                {this.state.panelArrays.map((item) => { return(
                    <TabPanel key={item.key} value={selectedIndex} index={item.key} >
                        <span className={classes.arrayConfig} >Array {item.arrayNumber} Configuration</span>
                        <DeleteIconButton onClick={() => { this.deleteArray(item.key);}} /> <br/>
                        <TableContainer component={Paper} className={classes.table} >
                        <Table  size="medium" aria-label="a dense table" border="0" >
                            <TableBody>
                                <TableRow size="small" key={item.key + '_1'} >
                                    <SmallCell cn={classes.tablecell} >Description</SmallCell>
                                    <SmallCell cn={classes.tablecell} >
                                <Input type="text" className={classes.input} required id="standard-required"  value={item.description} onChange={this.UpdateDescription} pattern="/(\b[a-z](?!\s))/g"/></SmallCell>
                                </TableRow>
                                <TableRow size="medium" key={item.key + '_3'} ><SmallCell cn={classes.tablecell} >Panel Config<br/>
                                    <FormControlLabel
                                    checked={true}
                                    value={true}
                                        control={<Checkbox  size="small" checked={this.state.dontupdateAll} onChange={this.DontUpdateAll } />}
                                        label={<Typography  style={{fontSize: 10}} >Don't update all</Typography>}
                                        labelPlacement="end" />
                                
                                </SmallCell>
                                <SmallCell colSpan={2} cn={classes.tablecell} >
                                <FormControl className={classes.numPanels} >
                                    <InputLabel id="lblNumPanels"># Panels</InputLabel>
                                    <Input  labelid ="lblNumPanels" 
                                    className={classes.numpanels_input} required  
                                    defaultValue={parseInt(curArray.numPanels)} 
                                    onChange={this.UpdateNumPanels} 
                                    inputProps={{step: "1",min: "1",max: "200",type: 'number'}}
                                    margin="dense" size="small" /> 
                                </FormControl><br/>
                                <FormControl className={classes.panelType} >
                                    <InputLabel id="panelTypeLabel">Panel Type</InputLabel>
                                    <Select
                                        labelid="panelTypeLabel"
                                        className={classes.numArraysSelectStyle}
                                        value={curArray.panel_id}
                                        onChange={this.handleUpdatePanels} 
                                        id= "panelId" 
                                        name="panelId" >
                                        {panels.map((item) => { 
                                            
                                            let retbat = []
                                            //console.log(`${pman} - ${item.manufacturer}`)
                                            if(pman !== item.manufacturer) {
                                                pman = item.manufacturer
                                                if(item.manufacturer != "a")
                                                    retbat.push(<ListSubheader >{item.manufacturer}</ListSubheader>)
                                            }
                                            retbat.push(
                                                    <MenuItem key={item.panel_id} value={parseInt(item.panel_id)}>
                                                    {!item.outofstock && <Icon style={{ color: green[500], fontSize: '14px' }}>done</Icon> }
                                                    {item.outofstock && <Icon style={{ color: red[500], fontSize: '14px' }}>do_not_disturb</Icon> }
                                                    <span style={{color: !item.outofstock ? "black" : "red" }}>
                                                    {item.description} 
                                                    </span>
                                                    </MenuItem>)
                                            return(retbat)   
                                        
                                            /*
                                            return ( <MenuItem key={item.panel_id} value={item.panel_id}>
                                            {!item.outofstock && <Icon style={{ color: green[500], fontSize: '14px' }}>done</Icon>}
                                            {item.outofstock && <Icon style={{ color: red[500], fontSize: '14px' }}>do_not_disturb</Icon>}
                                            <span style={{color: !item.outofstock ? "black" : "red" }}>
                                            { item.description }
                                            </span>
                                            </MenuItem> )} */
                                        })
                                        }
                                    </Select>
                                </FormControl>
                                </SmallCell>
                                </TableRow>   
                                <TableRow size="small" key={item.key + '_5'} ><SmallCell cn={classes.tablecell} >Roof Pitch</SmallCell>
                                <SmallCell cn={classes.tablecell} > <Input className={classes.input}  value={item.roofPitch} margin="dense" size="small" 
                                    onChange={this.handlePanelRoofPitchChange}
                                    inputProps={{step: "1",min: "0",max: "190",type: 'number'}} /></SmallCell></TableRow>
                                <TableRow size="small" key={item.key + '_7'} ><SmallCell cn={classes.tablecell} >Orientation</SmallCell>
                                <SmallCell cn={classes.tablecell}  ><Input className={classes.input} value={item.orientation} margin="dense"
                                    onBlur={this.panelCompassOnBlur}
                                    onChange={this.handlePanelCompassChange}
                                    inputProps={{step: "5",min: "0",max: "175",type: 'number'}} /></SmallCell></TableRow>
                                <TableRow size="small" key={item.key + '_9'} ><SmallCell cn={classes.tablecell} >Shading factor</SmallCell>
                                <SmallCell cn={classes.tablecell} ><Input className={classes.input} value={item.shading} margin="dense"
                                    //onBlur={this.panelCompassOnBlur}
                                    onChange={this.handlePanelShadingChange}
                                    inputProps={{step: "0.05",min: "0",max: "1",type: 'number'}}></Input>
                                </SmallCell>
                                </TableRow>
                                <TableRow>
                                    <SmallCell colSpan={2} cn={classes.buttonStyleContainer} >
                                    <FormGroup row>
                                        <ColorButton  variant="contained" color="primary" onClick={this.APICalcSolarArray} >Get Data</ColorButton>
                                        <FormControlLabel
                                              control={<Switch size="small" checked={curArray.birdprotection ? curArray.birdprotection : false } onChange={this.handleBirdProtection} value="birdprotection" /> }
                                              labelPlacement="top" label={<Typography style={{fontSize: 12}} >Add Bird Protection</Typography>}
                                        />
                                        <FormControl className={classes.installationLocationSelect} >
                                            <InputLabel id="installationLocationLabel">Installation Location</InputLabel>
                                            <Select
                                                labelid="InstallationLocationLabel"
                                                className={classes.installationLocationSelect}
                                                value={installation_location_id }
                                                onChange={this.handleInstallationLocation} 
                                                id= "InstallationLoationSelect" 
                                                name="InstallationLocationSelect" >
                                                {installation_location.map((item) => { return ( <MenuItem key={parseInt(item.installation_id)} value={parseInt(item.installation_id)} >{item.description}</MenuItem> )})}
                                            </Select>
                                        </FormControl>
                                    </FormGroup>
                                    </SmallCell>
                                </TableRow>
                                
                                <TableRow>
                                    <SmallCell colSpan={2} cn={classes.buttonStyleContainer} >
                                    <FormGroup row>
                                        <FormControl className={classes.installationLocationSelect} >
                                            <InputLabel id="solaroptimiserlabel">Solar Optimisers</InputLabel>
                                            <Select
                                                labelid="solaroptimiserlabel"
                                                className={classes.installationLocationSelect}
                                                value={solaroptimiser_uid }
                                                onChange={this.handleOptimiserChange} 
                                                id= "OptimisersSelect" 
                                                name="OptimisersSelect" >
                                                {optimisers.map((item) => { return ( <MenuItem key={parseInt(item.uid)} value={parseInt(item.uid)} >{item.description}</MenuItem> )})}
                                            </Select>
                                        </FormControl>
                                        {solaroptimiser_uid > 0 &&
                                            <FormControlLabel
                                                control={<Input size="small" className={classes.input}   value={qty_optimisers} readOnly={optimiser_type == 'SE' ? true : false } onChange={this.handleSolarOptimiserQty} /> }
                                                labelPlacement="top" label={<Typography style={{fontSize: 12}} >Qty</Typography>}
                                            />
                                        }

                                    </FormGroup>
                                    </SmallCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        </TableContainer>

                        {/* Panel Layout Sets for Rails/Hooks Calculation */}
                        <PanelLayoutSets
                            layoutSets={item.layoutSets || []}
                            totalPanels={item.numPanels || 0}
                            panelDimensions={{
                                width_mm: item.width_mm || 1134,
                                height_mm: item.height_mm || 1722
                            }}
                            onChange={(newSets) => this.handleLayoutSetsChange(item.key, newSets)}
                        />

                    </TabPanel>)
                    })
                }
            
            {hasItems && 
                <Grid container spacing={5} alignItems="flex-start" className={classes.grid} > 
                    <Grid item> 
                        <Typography className={classes.controlHeader} >Roof Pitch</Typography>
                        <RoofPitch onChange={this.getRoofPitchOnChangeEvente} roofpitch={this.state.panelArrays[this.state.currentArray].roofPitch} />
                    </Grid>
                    <Grid item>
                        <Typography className={classes.controlHeader}>Orientation</Typography>
                        <CompassControl onChange={this.getCompassOnChangeEvente}  degrees={this.state.panelArrays[this.state.currentArray].orientation } />
                    </Grid>
                </Grid> 
            }
        </div>
        )
    }
}

const styles = theme => ({
    root: {
        width: '520px',
        backgroundColor: 'white',
        borderWidth: 0,

    },
    tabpanel: {
        width: 500,
    },
    app_tab: {
        backgroundColor: '#ff00ff',
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 60,
    },
    numPanels: {
        minWidth: 80,
    },
    panelType: {
        minWidth: 150,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    input: {
        fontSize: 12,
    },
    numpanels_input: {
        fontSize: 12,
        paddingBottom: 3,
    },
    dont_updatelabel: {
        fontSize: 10,
    },
    ground_works_m: {
        fontSize: 12,
        paddingBottom: 1,
    },
    arrayConfig: {
        fontWeight: 'bold',
        textDecorationLine: 'underline',
        fontSize: 14,
    },
    grid : {
          marginLeft: 5,
    },
    primary: {
        color: '#ffffff',
    },
    secondary: {
        color: '#ff0000',
    },
    tab: {
        width: 50,
    },
    tabs: {
        fontSize: 10,
        background: '#6fcae7',
        color: '#fff'
    },
    button: {
        fontSize: 10,
    },
    table: {
        width: 500,
        boder: 1,
    },
    tablecell: {
        fontSize: 12,
        paddingBottom: 0,
        paddingTop: 2,

    },
    controlHeader: {
        fontSize: 10,
        alignText: 'center',
    },
    numArraysSelectStyle: {
        fontSize: 12,
        color: '#000000',
        paddingLeft: 5,
    },
    delteArrayIcon: {
        width: 5,
        borderWidth: 1,
        borderColor: 'red',
    },
    wosButton: {
        borderWidth: 1,
        borderColor: '#aaaaaa',
        backgroundColor: '#ffffff',
        fontSize: 12,
        paddingTop: 5,
        paddingBottom:5
    
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    buttonStyleContainer: {

    },
    installationLocationSelect: {
        width: 200,
        fontSize: 10
    },

  });

// Setup for Redux
const mapStateToProps = (state) => {
    return { 
        elecrate: state.elecrate,
        electric_estimated: state.electric_estimated     
    };
}; 

const mapDispatchToProps = {
    addoptimisers, 
    addpanels, 
    initpanels,
    addpaneltoarray,
    removefromarray
}

  // Connect our Redux stores to the Component
export default withStyles(styles, { withTheme: true })(connect( 
        mapStateToProps,
        mapDispatchToProps
    ) (CalculationPage));

